/**
 * Returns true unless NODE_ENV is production
 *
 * @returns {Boolean}
 */
export function logEnabled() {
  return process.env.NODE_ENV !== 'production';
}

/**
 * Logs an error to both newrelic and to the browser (if not production), with optional extra data
 *
 * @param {Error|String} err - The error or message to log
 * @param {Object} details - Any extra custom details to send to newrelic
 */
export default function logError(err, details = {}) {
  window.newrelic && window.newrelic.noticeError(err, details);
  if (logEnabled()) {
    console.error(err, details);
  }
}
